// extracted by mini-css-extract-plugin
export default {"block":"order_item_block__g53m3"};